/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReferenceNumberInfoDto } from '../../models/reference-number-info-dto';

export interface ApiReferencenumberGet$Params {
  'api-version'?: string;
}

export function apiReferencenumberGet(http: HttpClient, rootUrl: string, params?: ApiReferencenumberGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReferenceNumberInfoDto>>> {
  const rb = new RequestBuilder(rootUrl, apiReferencenumberGet.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReferenceNumberInfoDto>>;
    })
  );
}

apiReferencenumberGet.PATH = '/api/referencenumber';
